export default "__VITE_ASSET__DBARwM2y__"